import { Actions } from './actions';
import {
  GET_2359_REPORTS_REQUEST,
  GET_2359_REPORTS_SUCCESS,
  GET_2359_REPORTS_ERROR,
  GET_2359_REPORTS_FILTER,
} from './constants';
import { SecurityReport2359 } from './interfaces';

export const initialState = {
  reports: [] as SecurityReport2359[],
  allReports: [] as SecurityReport2359[],
  loading: false as boolean,
  error: null as null | Error,
};

export type Security2359ReportState = typeof initialState;

export const report2359Reducer = (state: Security2359ReportState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_2359_REPORTS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
        reports: [],
      };
    }
    case GET_2359_REPORTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        reports: action.payload.reports,
        allReports: action.payload.reports,
      };
    }
    case GET_2359_REPORTS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case GET_2359_REPORTS_FILTER: {
      return {
        ...state,
        loading: false,
        reports: action.payload.reports,
      };
    }
    default: {
      return state;
    }
  }
};
